import { Heart, ShieldCheck, Video } from "lucide-react";

// Owner-confirmed (Nov 2026): Kevin 6 years, Tony 3 years. No chauffeur photos yet.
export const CHAUFFEURS = [
  { name: "Kevin", years: 6 },
  { name: "Tony", years: 3 },
];

const STANDARDS = [
  { icon: ShieldCheck, text: "Fingerprinted and background-checked before they ever drive for us" },
  { icon: Video, text: "Cameras and AI driver-safety technology in every vehicle, for calm, careful driving" },
  { icon: Heart, text: "Licensed with the State of Georgia and commercially insured on every ride" },
];

/** "Meet the family": who drives for us. `compact` for landing pages. */
export default function FamilyChauffeurs({ compact = false }: { compact?: boolean }) {
  return (
    <section data-track-location="chauffeurs" className={`${compact ? "py-14 sm:py-16" : "section-padding"} bg-surface`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div>
          <p className="text-primary text-sm tracking-[0.3em] uppercase mb-4 font-medium">Who's Driving You</p>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground mb-5">
            Not a Corporation. A Family.
          </h2>
          <p className="text-muted-foreground text-lg leading-relaxed mb-4">
            We're a family business, not a typical corporate company. My chauffeurs have been with us for years,
            and they're an extension of my family. When I send one of them to you, I'm sending someone I trust
            with my own.
          </p>
          {!compact && (
            <p className="text-muted-foreground leading-relaxed">
              You won't get a stranger who started last week. You'll get a professional who knows Atlanta, knows how
              we do things, and takes pride in getting you there calmly and on your terms.
            </p>
          )}
        </div>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            {CHAUFFEURS.map((c) => (
              <div key={c.name} className="luxury-card rounded-lg p-5 sm:p-6 text-center">
                <span className="mx-auto mb-3 flex w-14 h-14 items-center justify-center rounded-full bg-accent font-heading text-2xl font-semibold text-primary">
                  {c.name[0]}
                </span>
                <p className="font-heading text-xl font-semibold text-foreground">{c.name}</p>
                <p className="text-muted-foreground text-sm">With us {c.years} years</p>
              </div>
            ))}
          </div>
          <ul className="luxury-card rounded-lg p-5 sm:p-6 space-y-3">
            {STANDARDS.map((s) => (
              <li key={s.text} className="flex items-start gap-3 text-foreground text-sm sm:text-base">
                <s.icon className="w-5 h-5 text-primary shrink-0 mt-0.5" aria-hidden="true" />
                <span>{s.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
